import PitchFxDataPack from './PitchFxDataPack';

const updatePitchFx = (state = {}, action) => {
    const { type = null, datasource, data = {} } = action;

    if (type === 'dataEngine_update_response') {

        if (datasource === 'gumbo') {
            let pitchfx = {};
            if (data?.liveData) {
                pitchfx = new PitchFxDataPack(data, data?.liveData?.plays?.currentPlay ?? {});
                return Object.assign({}, state, pitchfx);
            }
        }
        
        if (datasource === 'productConfig') {
            const { forceDefaultStadium, defaultStadium } = data;
            return Object.assign({}, state, { forceDefaultStadium, defaultStadium });
        }
    }

    return state;
};

export default updatePitchFx;
